import {useMutation, useQueryClient} from "react-query";
import {BrandingService} from "../../../services/BrandingService";
import {useParams} from "react-router";
import Alert from "react-s-alert";

export const useActivateBrandingTheme = () => {
  const {organizationId} = useParams<{organizationId: string}>();
  const queryClient = useQueryClient();

  return useMutation(
    async ({themeId}: {themeId: string}) => {
      const response = await BrandingService.activateTheme(
        organizationId,
        themeId,
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ["themes"]});
        Alert.success("Theme activated successfully");
      },
      onError: () => {
        Alert.error("Failed to activate theme");
      },
    },
  );
};
